import React, { useEffect, useRef } from 'react';
import './BackgroundCycle.css';

const images = [
  '/assets/backgrounds/background0.jpeg',
  '/assets/backgrounds/background1.jpeg',
  '/assets/backgrounds/background2.jpeg',
  '/assets/backgrounds/background3.jpeg',
  '/assets/backgrounds/background4.jpeg',
  '/assets/backgrounds/background5.jpeg',
  '/assets/backgrounds/background6.jpeg',
  '/assets/backgrounds/background7.jpeg',
];

const BackgroundCycle: React.FC = () => {
  const bg1Ref = useRef<HTMLDivElement>(null);
  const bg2Ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Preload images
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });

    let currentIndex = 0;
    let isBg1Active = true;

    const updateImages = () => {
      if (bg1Ref.current && bg2Ref.current) {
        if (isBg1Active) {
          // Fade out bg1, fade in bg2
          bg1Ref.current.style.opacity = '0';
          bg2Ref.current.style.backgroundImage = `url(${images[(currentIndex + 1) % images.length]})`;
          bg2Ref.current.style.opacity = '1';
        } else {
          // Fade out bg2, fade in bg1
          bg2Ref.current.style.opacity = '0';
          bg1Ref.current.style.backgroundImage = `url(${images[(currentIndex + 1) % images.length]})`;
          bg1Ref.current.style.opacity = '1';
        }
        isBg1Active = !isBg1Active;
        currentIndex = (currentIndex + 1) % images.length;
      }
    };

    // Initial setup
    if (bg1Ref.current && bg2Ref.current) {
      bg1Ref.current.style.backgroundImage = `url(${images[0]})`;
      bg1Ref.current.style.opacity = '1';
      bg2Ref.current.style.opacity = '0';
    }

    const interval = setInterval(updateImages, 12000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="background-container">
      <div className="bg bg1" ref={bg1Ref} />
      <div className="bg bg2" ref={bg2Ref} />
    </div>
  );
};

export default BackgroundCycle;